import { useState } from 'react';
import { ResumeProcessorOption } from './Resume';

interface UseResumeProcessorReturn {
  option: ResumeProcessorOption;
  setOptionPDF: () => void;
  setOptionURL: () => void;
}

const useResumeProcessor = (): UseResumeProcessorReturn => {
  const [option, setOption] = useState<ResumeProcessorOption>(ResumeProcessorOption.PDF);

  const setOptionPDF = (): void => {
    setOption(ResumeProcessorOption.PDF);
  };

  const setOptionURL = (): void => {
    setOption(ResumeProcessorOption.URL);
  };

  return {
    option,
    setOptionPDF,
    setOptionURL,
  };
};

export default useResumeProcessor;
export type { UseResumeProcessorReturn };
